import { render, staticRenderFns } from "./Mining.vue?vue&type=template&id=3ca00bab&scoped=true"
import script from "./Mining.vue?vue&type=script&lang=js"
export * from "./Mining.vue?vue&type=script&lang=js"
import style0 from "./Mining.vue?vue&type=style&index=0&id=3ca00bab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca00bab",
  null
  
)

export default component.exports